import { Data2, dateToString, newId } from '../../../features/data-types'
import { PreparationStatus } from '../../common'
import { useSystemStateHooks } from '../../system'
import { DeliveryRoadmap, Roadmap } from '../state/types'

export const useRoadmapBuilders = () => {
    const { companyId } = useSystemStateHooks()

    const buildRoadmap = (data: Data2) => {
        const { 
            id = newId(), 
            code, 
            branchId,
            driverId, 
            vehicleId, 
            date, 
            preparationStatus
        } = data
        
        const roadmap: Roadmap = {
            companyId: companyId!,
            id: id! as string,
            code: code! as number,
            branchId: branchId! as string,
            driverId: driverId! as string,
            vehicleId: vehicleId! as string,
            date: dateToString(date)!,
            preparationStatus: (preparationStatus || PreparationStatus.PENDING) as PreparationStatus
        }

        return roadmap
    }

    const buildDeliveryRoadmap = (data: Data2) => {
        const { 
            id = newId(), 
            deliveryId,
            roadmapId,
            order
        } = data
        
        const deliveryRoadmap: DeliveryRoadmap = {
            companyId: companyId!,
            id: id! as string,
            deliveryId: deliveryId! as string,
            roadmapId: roadmapId! as string,
            order: order! as number
        }

        return deliveryRoadmap
    }

    return {
        buildRoadmap,
        buildDeliveryRoadmap
    }
}
